import styled from "styled-components";

export const SpanRed = styled.span`
  color: var(--error-color);
`;
